// @ts-nocheck

import React from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useRouter } from "next/router";

import { PATH_ROUTES } from "@/config/routes";

const HeaderSolidContext = createContext(null);

export function HeaderSolidProvider({ children }: { children: React.ReactNode }) {
	const router = useRouter();

	const [isSolid, setIsSolid] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (
				[
					PATH_ROUTES.PATH_ACCOUNT_DASHBOARD,
					PATH_ROUTES.PATH_ACCOUNT_MY_PROFILE,
					PATH_ROUTES.PATH_ACCOUNT_JET_ONE_SUITES,
					PATH_ROUTES.PATH_ACCOUNT_CHARTER,
					PATH_ROUTES.PATH_ACCOUNT_AIR_FREIGHT,
					PATH_ROUTES.PATH_ACCOUNT_SETTINGS,
				].includes(router.pathname)
			) {
				setIsSolid(true);
			} else {
				setIsSolid(window.scrollY > 100);
			}
		};

		handleScroll();
		window.addEventListener("scroll", handleScroll);

		return () => window.removeEventListener("scroll", handleScroll);
	}, [router.pathname]);

	const headerSolid = (s = 0) => {
		setIsSolid(router.pathname.includes(PATH_ROUTES.PATH_AIRCRAFT_TYPES) ? s !== 6 : s > 0);
	};

	return <HeaderSolidContext.Provider value={{ isSolid, headerSolid }}>{children}</HeaderSolidContext.Provider>;
}

export function useHeaderSolid() {
	return useContext(HeaderSolidContext);
}
